import { Store } from "../../types/contexts/eligibleDependentContext/store.types";

const initialState: Store = {
	eligibleDependents: [],
	ineligibleDependents: [],
	ineligibleRelationshipDependents: []
};

export default initialState;
